import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {scrollToggleFixed} from '../../utils/scrollFixedNav';
import {iniciarContadorDesdeFechaBase, iniciarContadorEvitadoDesdeFechaBase} from '../../utils/counter-kilos.js';

document.addEventListener('DOMContentLoaded', function ()
{

    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#hero',
    });

    const breakpoint = window.matchMedia('(min-width: 90rem)');
    let swiperInstance = null;

    function initSwiper() {
        if (swiperInstance) return;

        swiperInstance = new Swiper('#modelos', {
            modules: [Navigation, Autoplay],
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next-modelos',
                prevEl: '.swiper-button-prev-modelos',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
            },
        });
    }

    function destroySwiper() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    function handleBreakpointChange() {
        if (breakpoint.matches) {
            destroySwiper();
        } else {
            initSwiper();
        }
    }

    breakpoint.addEventListener('change', handleBreakpointChange);
    handleBreakpointChange();

    iniciarContadorDesdeFechaBase();
    iniciarContadorEvitadoDesdeFechaBase();

    const swiperVideosEl = document.querySelector('.swiper-videos');
    if (swiperVideosEl) {
        const swiperVideos = new Swiper('.swiper-videos', {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            autoplay: true,
            speed: 1000,
            navigation: {
                prevEl: '.swiper-button-prev-videos',
                nextEl: '.swiper-button-next-videos',
            },
            breakpoints: {
                0:    { slidesPerView: 1, spaceBetween: 15 },
                640:  { slidesPerView: 2, spaceBetween: 20 },
                768:  { slidesPerView: 2, spaceBetween: 20 },
                1024: { slidesPerView: 2, spaceBetween: 15 },
                1280: { slidesPerView: 1, spaceBetween: 0  },
            },
        });
    }

    const swiperEntregadosEl = document.querySelector('.swiper-entregados');
    if (swiperEntregadosEl) {
        const swiperEntregados = new Swiper('.swiper-entregados', {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            autoplay: true,
            speed: 1000,
            navigation: {
                prevEl: '.swiper-button-prev-entregados',
                nextEl: '.swiper-button-next-entregados',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
            },
        });
    }


});
